module.exports = __webpack_public_path__ + "img/calendar.1b04bc74.svg";